import { InstanceScreen } from 'component/navigation/instance';

export default function AccountScreen() {
    return <InstanceScreen />;
}
